import { format } from 'date-fns';
import { useContext } from 'react';

import { ApplicationContext } from '../../../shared/source/context/context';
import { Text } from '../design/components/Typography';

import type { FunctionComponent } from 'react';

export const CopyrightTenant: FunctionComponent = () => {
    const { translate } = useContext(ApplicationContext);

    return <Text color="secondary">{`© ${format(new Date(), 'yyyy')} ${translate('common.brand')}`}</Text>;
};
